import { useSelector } from 'react-redux'

import { preview } from '@/components/form/preview'
import { selectMobileAppInteraction } from '@/features/domain/territory'

import { useCopyDriverAssistanceModal } from '../../modals/CopyDriverAssistanceModal'
import { DriverAssistanceType } from '../DriverAssistanceType'
import { Header } from './components/Header'

interface Props {
  onEdit: () => void
}

export function DriverAssistanceView(props: Props) {
  const { onEdit } = props

  // Get driver assistance from the domain state
  const driverAssistance = useSelector(selectMobileAppInteraction)

  // Instance the modal to copy driver assistance
  const { show: showCopyDriverAssistanceModal, Modal: CopyDriverAssistanceModal } =
    useCopyDriverAssistanceModal()

  return (
    <preview.Root
      applyPendingFitMapOnMount={false}
      rightBorder={false}
      header={<Header onEdit={onEdit} onCopy={showCopyDriverAssistanceModal} />}
      testId="driver-assistance-view"
    >
      <DriverAssistanceType driverAssistance={driverAssistance} />
      <CopyDriverAssistanceModal />
    </preview.Root>
  )
}
